import { render, staticRenderFns } from "./WeightsPage.vue?vue&type=template&id=f065fd24"
import script from "./WeightsPage.vue?vue&type=script&lang=ts"
export * from "./WeightsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports